import { useEffect, useMemo } from 'react';

const LINES_NAV_STATE_STORAGE_KEY = 'lineAssignments:linesNavigationState';

const getPersistedLinesNavigationState = () => {
  try {
    const persistedState = sessionStorage.getItem(LINES_NAV_STATE_STORAGE_KEY);
    return persistedState ? JSON.parse(persistedState) : {};
  } catch {
    return {};
  }
};

export const useLineNavigationState = (location) => {
  const navigationState = useMemo(() => {
    if (location.state && Object.keys(location.state).length > 0) {
      return location.state;
    }

    return getPersistedLinesNavigationState();
  }, [location.state]);

  const uuidFromPath = useMemo(
    () => new URLSearchParams(location.search).get('uuid') || '',
    [location.search],
  );

  const legalId = navigationState?.legal_id;
  const orderId = navigationState?.order_id;
  const storageKey =
    legalId && orderId ? `lineAssignmentsLines:${String(legalId)}:${String(orderId)}` : '';

  useEffect(() => {
    if (!location.state || Object.keys(location.state).length === 0) {
      return;
    }

    sessionStorage.setItem(LINES_NAV_STATE_STORAGE_KEY, JSON.stringify(location.state));
  }, [location.state]);

  return {
    navigationState,
    uuidFromPath,
    legalId,
    orderId,
    storageKey,
  };
};
